import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { RemoteAction } from '../../remote-action';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { ServiceRemoteActionBuilder } from '../service-remote-action-builder';
import { Pin } from 'src/app/_model/pin';
import { ExtFilesService } from 'src/app/_services/ext-files/logic/ext-files.service';

export class PinCreateRemoteActionBuilder extends ServiceRemoteActionBuilder {
  constructor(
    private pin: Pin,
    appService: AppService,
    credentialsService: CredentialsService,
    private extFileService: ExtFilesService,
    private logger?: LoggingService
  ) {
    super(
      appService,
      credentialsService,
      {
        endpoint: 'pincreate',
        authenticationRequired: true,
        fifo: true,
        cachable: true,
        data: {
          pin: JSON.stringify(pin),
        },
      },
      [],
      async (data: any) => {
        this.logger.log(
          this.constructor.name,
          ' Executing post pin create generate function'
        );
      },
      logger
    );
  }

  public async next(dataValues?: { key: string; value: any }[]): Promise<any> {
    return super.next(dataValues);
  }

  public async generateRemoteAction(
    dataValues: { key: string; value: any }[]
  ): Promise<RemoteAction> {
    let ra = await super.generateRemoteAction(dataValues);
    // Post processing of remote action

    ra.shortLabel = 'PAGE.DAYPROTOCOL.RA.SHORT';
    ra.shortLabelTranslate = true;

    const extFile = this.extFileService.getExtFileById({
      imsId: this.pin.extFileId,
      secondaryId: undefined,
      objRef: 'ims/ExtFile',
    });
    if (extFile) {
      ra.longLabel = this.pin.name + ' - ' + extFile.label;
    } else {
      ra.longLabel = 'unknown';
    }
    ra.longLabelTranslate = false;

    return ra;
  }
}
